export default __webpack_public_path__ + "142460596d03436475e3ebe544c45426.png";